import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import * as AssetManagersActions from './asset-managers.actions';

@Injectable()
export class AssetManagersEffects {
  private readonly action = inject(Actions);
  private readonly store = inject(Store);
  private readonly service = inject(ReferenceService);

  constructor() {}

  loadAssetManagers$ = createEffect(() =>
    this.action.pipe(
      ofType(AssetManagersActions.loadAssetManagers),
      tap(() => this.store.dispatch(AssetManagersActions.toggleAssetManagersLoading({ loading: true }))),
      mergeMap(({ productId }) =>
        this.service.referenceSasSecLookupGetAssetManagersByProductGet({ productId }).pipe(
          map((response) => {
            this.store.dispatch(AssetManagersActions.toggleAssetManagersLoading({ loading: false }));
            return AssetManagersActions.loadAssetManagersSuccess({ assetManagers: response.result || [] });
          }),
          catchError((error) => {
            this.store.dispatch(AssetManagersActions.toggleAssetManagersLoading({ loading: false }));
            return of(AssetManagersActions.loadAssetManagersFailure({ error }));
          }),
        ),
      ),
    ),
  );
}
